export default {"src":"/_next/static/media/Arrhythmias.574defeb.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};